export default {
  'en': {
    'heading': 'CHECK OUT WHAT WE\'RE CURRENTLY BUILDING',
    'paragraph': '<h5>We also blog about gateway-technology all the way down to the juicy technical bits on <a href=\'https://gatewayapi.com/blog/\'>the gatewayapi blog »</a></h5><!--<h5>Or sign up for our newsletter <a href=\'#\'>here »</a></h5>-->'
  },
  'da': {
    'heading': 'SE HVAD VI I ØJEBLIKKET ER I GANG MED AT BYGGE',
    'paragraph': '<h5>Vi blogger også om gateway-teknologi helt ned til saftige tekniske detaljer på <a href=\'https://gatewayapi.com/da/blog/\'>gatewayapi bloggen »</a></h5><!--<h5>Eller skriv dig op til vores nyhedsbrev her <a href=\'#\'>her »</a></h5>-->'
  }
}



// WEBPACK FOOTER //
// ./src/multilanguage/blog.js